<template>
  <div class="detail">
    <div v-html="props.text"></div>
    <ElButton class="application-btn" @click="toApplication">立即申请</ElButton>
  </div>
</template>

<script lang="ts" setup>
import { defineProps } from "vue";
import { ElButton } from "element-plus";
import { isTestEnv } from "../utils";

const props = defineProps<{ text: string; name: string; id: string }>();

const toApplication = () => {
  const link = `https://www${isTestEnv() ? "-uat" : ""}.ky-express.com/219.html?id=${
    props.id
  }&name=${encodeURI(props.name)}`;
  if (window.self !== window.top) {
    window.top.location.href = link;
  } else {
    window.open(link, "_self");
  }
};
</script>

<style scoped>
.detail {
  background: #f7f9fe;
  font-size: 14px;
  line-height: 24px;
  color: #03050d;
  padding: 30px 30px 40px 30px;
  /deep/ p {
    line-height: 24px !important;
    margin: 0;
  }
  .application-btn {
    width: 160px;
    height: 48px;
    font-size: #fff;
    background-color: #7e51e4;
    color: #fff;
    border-radius: 4px;
    margin: 50px auto 0;
    display: block;
    &:hover {
      background-color: #fff;
      color: #7e51e4;
      border-color: #7e51e4;
    }
  }
}
</style>
